module.exports = __webpack_public_path__ + "media/images/ac-wrap-2-d60d6403f249737617caaac159d7ca49.jpg";